import React from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Header, Message } from 'semantic-ui-react';
import styled from 'styled-components';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { CenteredLoader } from '@/components/utils/Loader';
import { SubscriptionDetail } from '@/types/subscriptions/subscription';
// FIXME: そもそもこの階層からimportしたくない。この時点でURL分けるべきでは?
import { Preview as SubscriptionPreview } from '@/components/pages/Subscription/Presentation/Preview';
import { DetailHeader } from './DetailHeader';

export type Props = {
  isDataFetched: boolean;
  subscription: SubscriptionDetail;
  cancelSubscription: () => Promise<void>;
};

export const Detail: React.FC<Props> = ({
  isDataFetched,
  subscription,
  cancelSubscription,
}) => {
  const { t } = useTranslation();
  const title = t('pages.subscription.detail.title');

  if (!isDataFetched) {
    return <CenteredLoader />;
  }

  return (
    <PageRootWrapper
      title={title}
      breadcrumbItems={[{ label: title }]}
      containerType="normal"
    >
      <Styled>
        <StyledHeader>{title}</StyledHeader>
        <div className="l-subscription-detail-header">
          <DetailHeader
            subscription={subscription}
            cancelSubscription={cancelSubscription}
          />
        </div>
        <Divider hidden={true} />
        <SubscriptionPreview
          mode="detail"
          isConnecting={false}
          subscription={subscription}
        />
        <Message color="grey" className="disclaimer">
          <p>{t('text.subscription.disclaimer.first')}</p>
          <p>{t('text.subscription.disclaimer.second')}</p>
        </Message>
      </Styled>
    </PageRootWrapper>
  );
};

const StyledHeader = styled(Header)`
  &&& {
    margin: 2em 0 1em;
    font-size: 1.5em;
  }
`;

const Styled = styled.div`
  .l-subscription-detail-header {
    margin-top: -3.5em;
  }
  .message.disclaimer p {
    font-size: 0.9em;
  }
`;
